import { render, staticRenderFns } from "./app-shortcuts-dock.component.vue?vue&type=template&id=3ead73c8"
import script from "./app-shortcuts-dock.component.vue?vue&type=script&lang=js"
export * from "./app-shortcuts-dock.component.vue?vue&type=script&lang=js"
import style0 from "./app-shortcuts-dock.component.vue?vue&type=style&index=0&id=3ead73c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports